<!-- Revised on 2024/12/11 by mnavarro -->
<template>
    <div class="pb-0 card-header">
        <div class="d-lg-flex gap-2">
            <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
            </div>
            <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2 gap-2 d-flex flex-wrap">
                    <!-- Edit actions (Add, clone and edit) -->
                    
                    <!-- Activate and deactivate actions -->
                    
                    <!-- Recover and delete actions -->
                    
                    <!-- Interactions with database (filters and reload) -->
                    <PurchaseOutboxQueueActionFilter id="purchaseOutboxQueueActionFilter" :filter-action-selected="listFilters?.action" @purchase-outbox-queue-action-filter-change="purchaseOutboxQueueActionFilterChange"/>
                    <PurchaseOutboxQueueStatusFilter id="purchaseOutboxQueueStatusFilter" :filter-status-selected="listFilters?.status" @purchase-outbox-queue-status-filter-change="purchaseOutboxQueueStatusFilterChange"/>
                    <ClearAllFiltersButton id="clearAllFiltersButton" :enable-clear-all-filters="checkActiveFilters()" @clear-all-filters="clearAllFilters"/>
                    <ReloadButton id="reload" :enable-reload="enableReload" @reload-page="reloadPage"/>
                </div>
            </div>
            <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                    <!-- Search space -->
                    <Searchbox id="searchbox" :enable-search="enableSearch" :filter-search="listFilters?.search" @search-change="searchChange"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ClearAllFiltersButton from "./../../../../../generic_components/ClearAllFiltersButton.vue";
    import PurchaseOutboxQueueActionFilter from "./../filters/PurchaseOutboxQueueActionFilter.vue";
    import PurchaseOutboxQueueStatusFilter from "./../filters/PurchaseOutboxQueueStatusFilter.vue";
    import ReloadButton from "./../../../../../generic_components/ReloadButton.vue";
    import Searchbox from "./../../../../../generic_components/Searchbox.vue";

    export default {
        name: "PurchaseOutboxQueueListTableHeader",
        components: {
            ClearAllFiltersButton,
            PurchaseOutboxQueueActionFilter,
            PurchaseOutboxQueueStatusFilter,
            ReloadButton,
            Searchbox
        },
        props: {
            title: {
                type: String,
                default: ""
            },
            description: {
                type: String,
                default: ""
            },
            enableReload: {
                type: Boolean,
                default: true
            },
            enableSearch: {
                type: Boolean,
                default: true
            },
            selectedIds: {
                type: Array,
                default: () => []
            },
            listFilters: {
                type: Object,
                default: () => ({})
            }
        },
        emits: ['clear-all-filters', 'purchase-outbox-queue-action-filter-change', 
                'purchase-outbox-queue-status-filter-change', 'search-change', 'reload-page'],
        methods: {
            checkActiveFilters() {
                return this.listFilters?.action !== '' || 
                       this.listFilters?.search !== '' ||
                       this.listFilters?.status !== '';
            },
            clearAllFilters() {
                this.$emit("clear-all-filters");
            },
            purchaseOutboxQueueActionFilterChange(action) {
                this.$emit("purchase-outbox-queue-action-filter-change", action);
            },
            purchaseOutboxQueueStatusFilterChange(status) {
                this.$emit("purchase-outbox-queue-status-filter-change", status);
            },
            reloadPage() {
                this.$emit("reload-page");
            },
            searchChange(searchValue) {
                this.$emit("search-change", searchValue);
            }
        }
    }

</script>